import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

import { CampaignCallDurationBucket } from '@/shared/types/campaigns';

/**
 * Four fixed duration buckets for one campaign's voice calls, always all four rows.
 *
 * `channels` is never sent: the function rejects an empty array and already defaults
 * to the three voice channels. `start_time`/`end_time` are omitted so the window is
 * the function's 189-day default, which is as far back as a campaign can be read.
 * `answered_only` is pinned to the card's copy rather than left to the server default.
 */
export const GET_CAMPAIGN_CALL_DURATION = gql`
  query CampaignCallDurationDistribution($campaignId: String!) {
    rows: campaign_call_duration_distribution(
      args: { campaign_id: $campaignId, answered_only: true }
    ) {
      bucket_order
      label
      min_seconds
      max_seconds
      call_count
      voicemail_count
      percentage
      total_count
      account_id
      duration_seconds
      voicemail_duration_seconds
    }
  }
`;

export const useCampaignCallDuration = (campaignId?: string) => {
  const { data, loading, error } = useQuery<{ rows: CampaignCallDurationBucket[] }>(
    GET_CAMPAIGN_CALL_DURATION,
    { variables: { campaignId: campaignId ?? '' }, skip: !campaignId }
  );

  return { data: data?.rows, isLoading: loading, isError: Boolean(error) };
};
